{
    "Components": {
        "Alert": {
            "ariaLabel": "close",
            "endChatError": "Failed to end session, please try again",
            "sessionEnded": "Your session has ended. You have been redirected back to the start page.",
            "messageError": "There was a problem connecting to your session, please try again"
        },
        "Body": {
            "latestMessage": "Latest Message",
            "loadMessages": "Load Messages",
            "newMessage": "New Message",
            "title": "How can we help?",
            "subtitle": "Hi! I'm Ring's customer support assistant. How can I help you today?"
        },
        "Bubble": {
            "sourceTitle": "Helpful Links"
        },
        "Event": {
            "defaultJoin": "A Ring team member has joined the live chat.",
            "customerJoin": "Transferred to live chat.",
            "agentJoin": "has joined the live chat.",
            "defaultLeft": "The Ring team member has left the live chat.",
            "customerLeft": "You have left the chat.",
            "agentLeft": "has left the live chat.",
            "idle": "You've been idle for a while. Let us know if we can help!",
            "idleContinue": "I'm still here, I just need more time",
            "idleEnd": "End Chat",
            "returned": "Welcome back! Let's continue the conversation."
        },
        "FeedbackCard": {
            "ariaLabelThumbsUp": "Thumbs Up",
            "ariaLabelThumbsDown": "Thumbs Down",
            "header": "Was this helpful?",
            "sent": "Thank you for your feedback",
            "thumbsDown": "I apologize that my response wasn't satisfactory. Would love to hear your feedback on how to improve.",
            "thumbsDownResponse": "Thank you for your feedback. Please try rephrasing your question.",
            "thumbsUp": "I'm glad that helped! Please let me know if there is anything else I can help with.",
            "RESPONSE_UNCLEAR": "Response unclear",
            "ISSUE_UNRESOLVED": "Did not resolve my issue",
            "NOT_HELPFUL": "Not helpful"
        },
        "Footer": {
            "ariaLabel": "Send",
            "placeholder": "Ask a brief question...",
            "subtext": "This chatbot uses generative AI to answer your questions. Please verify any important information provided in these responses before acting on it."
        },
        "Header": {
            "ariaLabelMenu": "More Menu",
            "ariaLabelMinimize": "Minimize",
            "badgeTitle": "BETA",
            "badgeDisabled": "Disconnected",
            "agentLabel": "Agent",
            "agentMessage": "Contact Support",
            "supportLabel": "Support",
            "transcriptLabel": "Transcript",
            "themeLabel": "Theme",
            "muteLabel": "Mute",
            "unmuteLabel": "Unmute",
            "feedbackLabel": "Give Feedback",
            "endLabel": "End Chat"
        },
        "NotificationCard": {
            "ariaLabelClose": "Close",
            "ariaLabelOpen": "Open",
            "notification": "New Message",
            "expand": "Click to expand"
        },
        "WidgetIcon": {
            "ariaLabel": "Chat for support"
        },
        "WelcomeScreen": {
            "ariaLabel": "Minimize",
            "button": "Start Chat",
            "title": "Thank you for contacting Ring",
            "subtitleHtml": "By continuing, you agree to the <a href='https://ring.com/terms'>Ring Terms of Service</a>. Information related to this chat may be collected and recorded. See our <a href='https://ring.com/privacy-notice'>Privacy Notice</a> for additional information.",
            "loading": "Initating Session...",
            "error": "Unable to initiate session, please try again"
        }
    }
}
